<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("placeholder.label_employee_search_code") }}</label>
            <CInput
              v-model="searchData.code_name"
              v-on:keyup.enter="search"
              :placeholder="this.$t('placeholder.label_employee_search_code')"
            />
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_division") }}</label>
            <select
              class="form-control"
              v-model="searchData.divisionCode"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-for="(item, index) in divisions"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_name_project") }}</label>
            <select
              class="form-control"
              v-model="searchData.projectName"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.id"
                v-for="(item, index) in projects.data"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="text-center btn-search">
          <CButton
            color="primary"
            class="btn-search-employee"
            @click.prevent="search"
          >
            {{ $t("button.label_employee_btn_search") }}</CButton
          >
          <CButton class="btn-reset" @click="resetForm">{{
            $t("button.label_action_reset")
          }}</CButton>
        </CCol>
      </CRow>
      <CRow alignHorizontal="end" style="padding-right: 20px">
        <b-button
          variant="primary"
          class="btn-search-employee"
          v-on:click="showModal"
        >
          {{ $t("button.label_edit_info") }}</b-button
        >
      </CRow>
      <template>
        <b-modal ref="my-modal" hide-footer hide-header>
          <p class="info" style="font-size: 16px; text-align: center">
            {{ $t("employee.label_employee_type_work") }}
          </p>
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label>{{ $t("employee.label_type_work") }}</label>
                <select class="form-control" v-model="type_work">
                  <option
                    :value="item.value"
                    v-for="(item, index) in options"
                    :key="index"
                  >
                    {{ item.type }}
                  </option>
                </select>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label>{{ $t("commons.label_reason") }}</label>
                <CInput
                  v-model="reason"
                  :placeholder="this.$t('placeholder.label_reason')"
                />
              </div>
            </CCol>
          </CRow>
          <label
            >{{ $t("employee.label_time") }}
            <span class="error-required" style="color: #ff1a1a">
              ({{ $t("employee.label_valid")}})</span
            ></label
          >
          <CRow>
            <CCol sm="6">
              <div class="form-group">
                <label>{{ $t("project.label_project_start_date") }}</label>
                <DatePickerFormFlex
                  :propsDate="start_date"
                  @emitDate="startDate"
                  v-model="start_date"
                />
              </div>
            </CCol>
            <CCol sm="6">
              <div class="form-group">
                <label>{{ $t("project.label_project_end_date") }}</label>
                <DatePickerFormFlex
                  :propsDate="end_date"
                  @emitDate="endDate"
                  v-model="end_date"
                />
              </div>
            </CCol>
          </CRow>
          <CRow
            alignHorizontal="center"
            v-if="this.start_date <= this.end_date"
          >
            <div class="btn-submit" style="padding: 15px 0">
              <b-button
                class="btn-save"
                @click="handleSave"
                style="margin-right: 15px"
                variant="primary"
                >{{ $t("button.label_action_create") }}</b-button
              >
              <b-button class="btn-save" @click="hideModal">{{
                $t("button.label_action_cancel")
              }}</b-button>
            </div>
          </CRow>
          <CRow alignHorizontal="center" v-else>
            <div class="btn-submit" style="padding: 15px 0">
              <b-button
                class="btn-save"
                disabled
                @click="handleSave"
                style="margin-right: 15px"
                variant="primary"
                >{{ $t("button.label_action_create") }}</b-button
              >
              <b-button class="btn-save" @click="hideModal">{{
                $t("button.label_action_cancel")
              }}</b-button>
            </div>
          </CRow>
        </b-modal>
      </template>
    </CCard>
    <CRow class="table">
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option
                    v-for="(item, index) in listItemsPerPage"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
              </div>
              <template
                v-if="
                  listEmployeeTypeWorks.data &&
                  listEmployeeTypeWorks.data.length > 0
                "
              >
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ $t("commons.label_text_to") }}
                  {{ searchData.paginate.to }}
                  {{ $t("commons.label_text_of") }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              <template v-else>
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ searchData.paginate.to }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
            </div>
            <div class="table-responsive">
              <table class="table table-mobile">
                <thead>
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        @click="checkAll()"
                        v-model="isCheckAll"
                      />
                      Tất cả
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_code") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_division") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_type_work") }}
                    </th>
                    <th scope="col">
                      {{ $t("commons.label_start_date") }}
                    </th>
                    <th scope="col">
                      {{ $t("commons.label_end_date") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-if="
                      listEmployeeTypeWorks.data &&
                      listEmployeeTypeWorks.data.length > 0
                    "
                  >
                    <tr
                      v-for="(item, index) in listEmployeeTypeWorks.data"
                      :key="index"
                    >
                      <th scope="row">
                        <input
                          style="margin-top: 5px"
                          type="checkbox"
                          v-bind:value="item.id"
                          v-model="employee_id"
                          @change="updateCheckall()"
                        />
                        {{
                          (listEmployeeTypeWorks.current_page - 1) *
                            listEmployeeTypeWorks.per_page +
                          index +
                          1
                        }}
                      </th>
                      <td>{{ item.id }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.department ? item.department.name : "" }}</td>
                      <td>
                        {{
                          item.remote_working
                            ? item.remote_working.type === 1
                              ? "Làm việc tại công ty"
                              : "Làm remote"
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          item.remote_working
                            ? formatDate(item.remote_working.start_date)
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          item.remote_working
                            ? formatDate(item.remote_working.end_date)
                            : ""
                        }}
                      </td>
                    </tr>
                  </template>
                  <template>
                    <tr>
                      <td colspan="12" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_type_work"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    DatePickerFormFlex,
  },
  data: function () {
    return {
      isCheckAll: false,
      employee_id: [],
      disableButton: false,
      options: [
        { id: 1, value: 1, type: "Làm việc công ty" },
        { id: 2, value: 2, type: "Làm remote" },
      ],
      searchData: {
        code_name: "",
        divisionCode: "",
        projectName: "",
        itemsPerPage: 10,
        footCode: 0,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 0,
          totalRecord: 0,
          perPage: 0,
        },
      },
      type_work: 1,
      reason: "",
      start_date: Intl.DateTimeFormat("en-IN").format(new Date()),
      end_date: Intl.DateTimeFormat("en-IN").format(new Date()),
    };
  },
  computed: {
    ...mapGetters({
      divisions: "commons/divisions",
      projects: "type-work/projects",
      listItemsPerPage: "commons/listItemsPerPage",
      listEmployeeTypeWorks: "type-work/listEmployeeTypeWorks",
      pagination: "type-work/pagination",
      account: "auth/account",
    }),
  },

  methods: {
    ...mapActions("type-work", ["fetchTypeWorkEmployee"]),
    ...mapActions("layout", ["setLoading"]),

    showModal() {
      this.$refs["my-modal"].show();
    },

    hideModal() {
      this.$refs["my-modal"].hide();
    },

    startDate(data) {
      this.start_date = data;
    },
    endDate(data) {
      this.end_date = data;
    },

    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    async fetchEmployeeTypeWork() {
      await this.fetchTypeWorkEmployee({
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        name: this.searchData.code_name.toLowerCase(),
        divisionCode: this.searchData.divisionCode,
        projectName: this.searchData.projectName,
      });
      this.searchData.paginate = this.pagination;
    },

    async search() {
      this.setLoading(true);
      try {
        await this.fetchEmployeeTypeWork();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    changePage(page) {
      this.fetchEmployeeTypeWork(this.searchData.itemsPerPage, page);
    },
    resetForm() {
      this.searchData.code_name = "";
      this.searchData.divisionCode = "";
      this.searchData.project_name = "";
    },
    getProjects() {
      this.$store.dispatch("type-work/projects");
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.employee_id = [];
      if (this.isCheckAll) {
        // Check all
        for (const items in this.listEmployeeTypeWorks.data) {
          this.employee_id.push(this.listEmployeeTypeWorks.data[items]["id"]);
        }
      }
    },
    updateCheckall() {
      if (this.employee_id.length === this.listEmployeeTypeWorks.data.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    async handleSave() {
      this.setLoading(true);
      await this.$store
        .dispatch("type-work/updateTypeWork", {
          employee_id: this.employee_id,
          type: this.type_work,
          reason: this.reason,
          start_date: this.start_date.split("/").reverse().join("-"),
          end_date: this.end_date.split("/").reverse().join("-"),
          created_by: this.account.account_id,
          updated_by: this.account.account_id,
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_create_info"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.fetchEmployeeTypeWork();
          this.hideModal();
          this.employee_id = [];
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
  },
  async created() {
    await this.fetchEmployeeTypeWork();
    await this.getProjects();
  },
};
</script>
<style lang="scss" scoped>
.employee {
  margin: -2rem -30px 30px -30px;
  .card-table-emloyee {
    padding: 30px;
  }
  .employee-table {
    margin: 15px 5px;
    .cl-pointer {
      cursor: pointer;
      .icon-sort {
        margin-left: 5px;
        .c-icon {
          width: 12px;
        }
        .sort-rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  .table {
    margin-top: -15px;
  }
  .error-required {
    color: #ff1a1a;
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
    .log-action {
      margin-left: auto;
      margin-right: 20px;
    }
  }
  .btn-search {
    margin-top: 15px;
  }
  .btn-search-employee {
    background-clip: #4f5d73;
  }
}
.require {
  color: #ff1a1a;
}
th,
td {
  vertical-align: middle !important;
}
@media only screen and (max-device-width: 767px) {
  .employee-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1500px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .employee-table {
    margin: 1rem;
  }
  .table-tablet {
    width: 1500px;
    overflow-x: scroll;
  }
}
</style>